module.exports = __webpack_public_path__ + "img/xlm-trading-pair.7ff8d07e.png";